import { NPKCatalogs } from "@smartdevis/server/src/domain"
import { Authentication } from "../../../../store/authState"
import { useEffect, useState } from "react"
import { getSubscribedWorkStations, unSubscribeWorkStation } from "."
import { FlexRow } from "@smartdevis/ui/src/utils/common"
import React from "react"
import { H3 } from "@smartdevis/ui/src/Typography"

type WorkstationProps = {
    auth: Authentication
    credentials: NPKCatalogs.Credentails
}
export const ActiveWorkStations = (p: WorkstationProps) => {

    const [activeWorkStations, setActiveWorkStations] = useState<Array<NPKCatalogs.Workstation>>()

    const fetchSubscribedWorkstations = () => getSubscribedWorkStations(p.auth, { customerID: p.credentials.customerID, licenseID: p.credentials.licenseID }).then((res) => {
        const _activeWorkstations: NPKCatalogs.Workstation[] = res.value as NPKCatalogs.Workstation[];
        setActiveWorkStations(_activeWorkstations);
    }).catch(err => err)

    useEffect(() => {
        if (!activeWorkStations) fetchSubscribedWorkstations();
    }, [activeWorkStations])

    const _unSubscribeWorkStation = (workStationID: string) => {
        const { customerID, licenseID } = p.credentials
        unSubscribeWorkStation(p.auth, { customerID, licenseID, workStationID }).then((res) => fetchSubscribedWorkstations());
    }

    return <ul style={{ display: "grid", gridTemplateColumns: 'repeat(4, 1fr)', listStyle: 'none' }}>
        {activeWorkStations && activeWorkStations.map((workstation, key) =>
            <li key={key}>
                <FlexRow spaceAround style={{ border: '1px solid black', padding: '2rem', margin: '5px' }}>
                    <input type="checkbox" onClick={() => _unSubscribeWorkStation(workstation.id)} />
                    <H3>{workstation.id}</H3>
                </FlexRow>
            </li>
        )}
    </ul>
}